export enum TestPlanLabType {
  TestsigmaLab = 'TestsigmaLab',
  Hybrid = 'Hybrid',
  SauceLabs = 'SauceLabs',
  BrowserStack = 'BrowserStack',
  PrivateGrid = 'PrivateGrid',
  LambdaTest = 'LambdaTest',
  Kobiton = 'Kobiton',
}
